import { ArrowRightOutlined } from '@ant-design/icons'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { theme } from 'antd'
import type { ChangeRowProps } from '../types'

export function ChangeRow({ label, beforeValue, afterValue }: ChangeRowProps) {
  const { token } = theme.useToken()
  const isUnchanged = beforeValue === afterValue

  const labelStyle = {
    width: 100,
    flexShrink: 0,
    textTransform: 'uppercase' as const,
    fontSize: 11,
    fontWeight: 500,
    color: token.colorTextTertiary,
  }

  // For unchanged fields, show a simpler single-value display
  if (isUnchanged) {
    return (
      <Horizontal gap={12} alignItems='center' style={{ padding: '4px 0' }}>
        <Texto style={labelStyle}>{label}</Texto>
        <Texto
          style={{ fontSize: 13, flex: 1, color: token.colorTextSecondary }}
        >
          {afterValue || '—'}
        </Texto>
      </Horizontal>
    )
  }

  return (
    <Horizontal gap={12} alignItems='center' style={{ padding: '4px 0' }}>
      <Texto style={labelStyle}>{label}</Texto>

      <Texto
        style={{
          fontSize: 13,
          flex: 1,
          color: token.colorTextTertiary,
          textDecoration: 'line-through',
        }}
      >
        {beforeValue || '—'}
      </Texto>

      <ArrowRightOutlined
        style={{ color: token.colorTextTertiary, fontSize: 12 }}
      />

      <Texto
        style={{
          fontSize: 13,
          flex: 1,
          fontWeight: 600,
          color: token.colorText,
        }}
      >
        {afterValue || '—'}
      </Texto>
    </Horizontal>
  )
}
